import { useAppSearchParams } from 'shared/libs/hooks/useAppSearchParams'
import { getOffset } from 'shared/libs/pagination/offset'
import { OrdersStatusKey } from 'shared/types/Common'

import { useEffect, useMemo } from 'react'

import { useParams } from 'react-router-dom'

import {
  changeOrdersParams,
  clearOrders,
} from 'modules/Orders/model/ordersSlice'
import { useLazyGetOrdersQuery } from 'modules/Orders/services/ordersApi'
import { ChangeOrdersParams } from 'modules/Orders/types'

import {
  useAppDispatch,
  useAppSelector,
} from 'shared/config/redux/hooks/useRedux'

interface Params {
  status: OrdersStatusKey
}

export const useOrders = ({ status }: Params) => {
  const dispatch = useAppDispatch()
  const { restaurant } = useParams()
  const { getAllParams } = useAppSearchParams()
  const {
    branch,
    delivery_type,
    delivery_way,
    payment_method,
    start_date,
    end_date,
    search,
    status: filterStatus,
  } = getAllParams()

  const {
    orders,
    restaurant: stateRestaurant,
    isAllReset,
  } = useAppSelector((state) => state.orders) || {}

  const { page, limit, data, count, isUpdate } =
    useMemo(() => orders?.[status], [orders]) || {}
  const offset = useMemo(
    () => (page && limit ? getOffset(page, limit) : undefined),
    [page, limit],
  )
  const lastPage = useMemo(
    () => data && Number(Object.keys(data).sort().at(-1)),
    [data],
  )

  const [getOrders, { isFetching }] = useLazyGetOrdersQuery()

  const handeChangeOrdersParams = (body: ChangeOrdersParams) => {
    setTimeout(() => {
      dispatch(changeOrdersParams(body))
    })
  }

  const handleGetOrders = async () => {
    if (typeof isUpdate !== 'boolean') return
    if (
      typeof limit === 'number' &&
      typeof offset === 'number' &&
      stateRestaurant &&
      start_date &&
      end_date &&
      (!filterStatus || filterStatus.includes(status))
    ) {
      getOrders({
        params: {
          company: stateRestaurant,
          limit: `${limit}`,
          offset: `${offset}`,
          branch,
          delivery_type,
          delivery_way,
          payment_method,
          start_date,
          end_date,
          search,
          status,
        },
      })
        .unwrap()
        .finally(() => {
          handeChangeOrdersParams({ status, isFetching: false })
        })
    } else {
      dispatch(clearOrders({ status }))
    }
  }

  useEffect(() => {
    handleGetOrders()
  }, [stateRestaurant, offset, limit, status, getAllParams, isUpdate])

  useEffect(() => {
    if (restaurant) {
      handeChangeOrdersParams({
        page: 1,
        limit: 10,
        restaurant,
        status,
        isUpdate: false,
        isFetching: true,
      })
    }
  }, [restaurant, getAllParams])

  return {
    ordersData:
      data &&
      Object.values(data).flatMap((ordersPage) => ordersPage?.results || []),
    limit,
    count,
    intersectionObserverIndex: 7,
    handeChangeOrdersParams,
    lastPage,
    page,
    pages: data && Object.keys(data),
    handleGetOrders,
    stateRestaurant,
    isUpdate,
    isFetching,
    isAllReset,
  }
}
